import {Component, Host, Input, OnDestroy, OnInit, Optional} from '@angular/core';
import {OsmService} from '../osm.service';
import {OsmMapComponent} from '../osm-map/osm-map.component';
import {takeUntil} from 'rxjs/operators';
import {Subject, Subscription} from 'rxjs';

@Component({
    selector: 'osm-semicircle',
    templateUrl: './osm-semicircle.component.html',
    styleUrls: [
        './osm-semicircle.component.scss'
    ],
    standalone: false
})
export class OsmSemicircleComponent implements OnInit, OnDestroy {

  private ngDestroy = new Subject();
  private L;
  private _point;

  public semicircle;
  public mapSubscribe: Subscription;

  @Input() public iMap: OsmMapComponent = null;
  @Input() private data;
  @Input() public angles;

  @Input() private get point() {
    return this._point;
  }

  private set point(value) {
    this._point = value;

    if (this.semicircle) {
      this.semicircle.setLatLng(this._point);
    }
  }

  public get map() {
    return this.pMap || this.iMap;
  }

  constructor(private o: OsmService,
              @Optional() @Host() private pMap: OsmMapComponent) { }

  ngOnInit(): void {
    this.mapSubscribe = this.o.$getMap
      .pipe(takeUntil(this.ngDestroy))
      .subscribe((L) => {
        if (!L) { return; }

        this.L = L;

        this.map.ready.then(_ => this.whenMapReady());
      });
  }

  ngOnDestroy(): void {
    this.o.dropSemiCircle(this.map, this.semicircle);
    if (this.mapSubscribe) {
      this.mapSubscribe.unsubscribe();
    }
  }

  whenMapReady() {
    const center = this.point || this.o.getMap(this.map).getCenter();

    this.semicircle = this.L.semiCircle(this.point, {
      radius: 50,
      startAngle: this.angles[0],
      stopAngle: this.angles[1],
      fillColor: '#ffffff',
      fillOpacity: 0.4,
      color: 'rgb(222, 29, 37)',
    });

    this.o.displaySemiCircle(this.map, this.semicircle);
  }

}
